import { derive } from 'store-utils';
import { createAsyncState } from 'async-utils';
import { Nullable } from 'common-types';
import { createStore } from 'store-utils';
import { FilterPipelineSummaryType } from '../pipeline-summary-types';

export const initialPipelineSummaryFiltersStoreValues = {
  loadingFilters: createAsyncState(),
  pipelineSummaryFilterValue: '',
  pipelineSummaryFiltersTypeSearch: null,
  pipelineSummaryFiltersType: null,
  filterBy: {},
  searchValues: {},
  totalFiltered: 0,
};

const baseStore = createStore<PipelineSummaryiltersStoreState>(
  initialPipelineSummaryFiltersStoreValues,
  'Pipeline Summary Filters Store',
);

const PipelineSummaryFiltersStore = derive(
  {
    numberOfFilters: get => {
      const { filterBy } = get(baseStore);
      return (
        Object.keys(filterBy).reduce(
          (acc, key) => acc + filterBy[key].length,
          0,
        ) || 0
      );
    },
  },
  { proxy: baseStore },
);

export interface PipelineSummaryiltersStoreState {
  loadingFilters: ReturnType<typeof createAsyncState>;
  pipelineSummaryFiltersTypeSearch: Nullable<FilterPipelineSummaryType>;
  pipelineSummaryFiltersType: Nullable<FilterPipelineSummaryType>;
  filterBy: {};
  totalFiltered: number;
  searchValues: {};
  pipelineSummaryFilterValue: string;
}

export default PipelineSummaryFiltersStore;
